import { FC } from 'react';
import { PreloadedQuery } from 'react-relay';
import { ExitSlipClassExitSlipsQuery } from '../../../graphQLOperations/__generated__/ExitSlipClassExitSlipsQuery.graphql';
import ExitSlipSnapshot from './ExitSlipSnapshot';
import { ExitSlipAllClassExitSlipQuery } from '../../../graphQLOperations/__generated__/ExitSlipAllClassExitSlipQuery.graphql';

interface Props {
  queryExitSlipRef: PreloadedQuery<ExitSlipClassExitSlipsQuery, Record<string, unknown>>;
  queryAllExitSlipRef: PreloadedQuery<ExitSlipAllClassExitSlipQuery, Record<string, unknown>>;
  dateExitSlip: Date;
  setDateExitSlip: (d: Date) => void;
}

const ExitSlipSnapshotWrapper: FC<Props> = ({
  queryExitSlipRef,
  queryAllExitSlipRef,
  dateExitSlip,
  setDateExitSlip,
}) => {
  return (
    <>
      {queryExitSlipRef && (
        <ExitSlipSnapshot
          queryExitSlipRef={queryExitSlipRef}
          queryAllExitSlipRef={queryAllExitSlipRef}
          dateExitSlip={dateExitSlip}
          setDateExitSlip={setDateExitSlip}
        />
      )}
    </>
  );
};

export default ExitSlipSnapshotWrapper;
